var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-row',{staticClass:"font-weight-medium",staticStyle:{"flex-wrap":"nowrap"},attrs:{"align":"center"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.label))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }